import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DefaultButton, DirectionalHint } from '@bingads-webui-react/fabric-control';
import { siteMapPropType } from '@bingads-webui-react/with-site-map';
import { Glyphicon } from '@bingads-webui-react/primitive';
import { genereateMenuProps } from './multilevel-dropdown-items';
import { getButtonClassNames } from './utilities';
import { StyledHeader } from './header';

export class MultiLevelDropDown extends React.PureComponent {
  renderDropdownIcon = () => null;

  renderGlyphIcon = classes => <Glyphicon className={classes.multiLevelDropDownButtonIcon} glyph="ba-Chart" />

  renderLabel = (classes, i18n, responsiveSize) => (<StyledHeader
    key="reports-header-button"
    className={classes.multiLevelDropDownLabel}
    text={i18n.getString(_TL_('Reports'))}
    responsiveSize={responsiveSize}
  />)

  render() {
    const {
      classes,
      i18n,
      siteMap,
      responsiveSize,
    } = this.props;
    const menuProps = genereateMenuProps(siteMap, classes, i18n);

    menuProps.directionalHint = DirectionalHint.bottomLeftEdge;
    menuProps.className = classNames([classes.menuContainer, 'global-menu-reports-dropdown-menu']);
    menuProps.calloutProps = {
      preventDismissOnScroll: true,
    };

    return (
      <DefaultButton
        menuProps={menuProps}
        id="reports"
        key="2"
        persistMenu
        onRenderText={() => this.renderLabel(classes, i18n, responsiveSize)}
        onRenderMenuIcon={this.renderDropdownIcon}
        onRenderIcon={() => this.renderGlyphIcon(classes)}
        className={classNames(getButtonClassNames(
          classes,
          ['global-menu-reports-dropdown-toggle'],
          responsiveSize
        ), classes.reportsButton, 'btn', 'btn-primary')}
      />
    );
  }
}

MultiLevelDropDown.propTypes = {
  classes: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
  responsiveSize: PropTypes.string.isRequired,
  siteMap: siteMapPropType.isRequired,
};
